import { render, staticRenderFns } from "./principal.vue?vue&type=template&id=651d9b7b"
import script from "./principal.vue?vue&type=script&lang=js"
export * from "./principal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports